import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';
import { CommonService } from '../Model/Common/common.service';
import { Router, RouterModule } from '@angular/router';
import { SessionService } from '../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { PostingOrderService } from '../posting-order.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ComboService } from '../Model/Combo/combo.service';
import { AllotmentDetailService } from '../allotment-detail.service';

@Component({
  selector: 'app-transfer-order-view',
  standalone: true,
  imports: [LoaderComponent, CommonModule, RouterModule, DataTablesModule, NgSelectModule, FormsModule],
  templateUrl: './transfer-order-view.component.html',
  styleUrl: './transfer-order-view.component.scss'
})
export class TransferOrderViewComponent {

  isDisabled: boolean = false;
  isSubContractor: boolean = false;
  user: any;

  TableData = [] as any;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private download: DownloadSampleService,
    private router: Router,
    public common: CommonService,
    private session: SessionService,
    private postingService: PostingOrderService,
    private comboload: ComboService,
    private allotmentService: AllotmentDetailService
  ) {
    // this.common.getPageRights();
    this.isSubContractor = window.location.pathname.includes('transferordersub');
    this.user = this.session.GetUserDetails();
    this.Filter.LoginUserID = this.user.UserId
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Filter = {
    SelectType: 'Transfer Order',
    EmpMasterID: '0',
    LoginUserID: '0',
    // ClientID: '0',
    DesignationID: '',
    GroupID: '',
    DutyID: '',
    BankAccountNo: '',
    // BranchID: '',
    FinancialYear: '',
    BranchId: null as any,
    ClientId: null as any,
    SiteId: null as any
  }

  SubContractorData() {
    this.isDisabled = true
    this.postingService.SubContractorDocument(this.Filter).subscribe({
      next: (response) => {
        this.TableData = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  // GetData() {
  //   this.isDisabled = true
  //   this.postingService.loadData(this.Filter).subscribe({
  //     next: (response) => {
  //       this.TableData = Object.values(response.Table);
  //       this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //         dtInstance.destroy();
  //         this.dtTrigger.next(null);
  //       });
  //       this.isDisabled = false;
  //     },
  //     complete: () => { this.isDisabled = false; },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  GetData() {
    this.isDisabled = true
    this.allotmentService.AllotmentView({
      SelectType: 'Transfer Order',
      LoginUserID: Number(this.user.UserId),
      BranchId: this.Filter.BranchId == null ? 0 : this.Filter.BranchId,
      ClientId: this.Filter.ClientId == null ? 0 : this.Filter.ClientId,
      SiteId: this.Filter.SiteId == null ? 0 : this.Filter.SiteId,
    }).subscribe({
      next: (response) => {
        // this.TableData = Object.values(response.Table);
        this.TableData = response.Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel() {
    if (this.TableData.length > 0) {
      this.download.exportToExcel(this.TableData, "Transfer Order Data");
      this.isDisabled = false
    }
    else {
      alert('No Data Found');
      this.isDisabled = false
    }
  }

  ComboLoad(Combotype: String) {
      this.isDisabled = true;
      if (Combotype == 'Site') {
        this.Filter.SiteId = null;
        this.Sites = [];
      } else if (Combotype == 'Client') {
        this.Filter.ClientId = null;
        this.Filter.SiteId = null;
        this.Clients = [];
        this.Sites = [];
      }
      this.comboload.ComboLoad({
        'Combotype': Combotype,
        'UserType': 'A',
        'BranchId': this.Filter.BranchId,
        'ClientId': this.Filter.ClientId,
        'SiteId': this.Filter.SiteId,
        'EmpType': 'front',
      }).subscribe({
        next: (response) => {
          if (response.ComboLoad) {
            if (Combotype == 'Branch') {
              this.Branchs = response.ComboLoad;
            } else if (Combotype == 'Client') {
              this.Clients = response.ComboLoad;
            } else if (Combotype == 'Site') {
              this.Sites = response.ComboLoad;
            } 
          }
          this.isDisabled = false;
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    }


}
